import {ref, Ref} from 'vue';
export class EditorSplitPanelsControllerClass {
	private static _instance: EditorSplitPanelsControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorSplitPanelsControllerClass());
	}

	private constructor() {
		window.addEventListener('resize', this.onResize.bind(this));
	}

	private _dragInProgress: Ref<boolean> = ref(false);
	private _windowResizeInProgress: Ref<boolean> = ref(false);
	private _timeout: number | undefined;

	onResize() {
		this._windowResizeInProgress.value = true;
		if (this._timeout) {
			clearTimeout(this._timeout);
		}
		this._timeout = setTimeout(() => {
			this._windowResizeInProgress.value = false;
		}, 1000) as any /* the build fails if we use the node type NodeJs.Timeout */;
	}

	// getters
	dragInprogress() {
		return this._dragInProgress.value;
	}
	windowResizeInProgress() {
		return this._windowResizeInProgress.value;
	}

	// mutations
	setDragInProgress(state: boolean): void {
		this._dragInProgress.value = state;
	}
}

export const SplitPanels = EditorSplitPanelsControllerClass.instance();
